import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { UserLogin } from '../interfaces/user_login';
import { catchError, Observable, throwError } from 'rxjs';
import { BASEURL, LOGIN } from '../constant/url';
import { Router } from '@angular/router';
import { User } from '../interfaces/user';
import { EMAIL, ID_USER, TOKEN, USERNAME } from '../constant/storage';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly _http = inject(HttpClient);
  private readonly _router = inject(Router);

  private readonly _role = signal<string | null>(null);
  readonly role$ = toObservable(this._role);

  constructor() { }

  public initializeUserRole(): void {
    const token = localStorage.getItem(TOKEN);
    if (token) {
      this.fetchUserRole().subscribe((user) => {
        const role = user.role?.id || null;
        this._role.set(role);
      });
    }
  }

  login(data: UserLogin): Observable<any> {
    return this._http.post(LOGIN, data).pipe(catchError(this.handleError));
  }

  doLoginUser(
    token: string,
    username: string,
    email: string,
    role: string,
    idUser: string
  ) {
    localStorage.setItem(TOKEN, token);
    localStorage.setItem(USERNAME, username);
    localStorage.setItem(EMAIL, email);
    localStorage.setItem(ID_USER, idUser);
    this._role.set(role);
    this.initializeUserRole();
    this._router.navigate(['/']);
  }

  fetchUserRole(token?: string): Observable<User> {
    const headers: { [header: string]: string } = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return this._http.get<User>(BASEURL + 'users/me?populate=role', {
      headers,
    }).pipe(catchError(this.handleError));
  }

  getRoleObservable(): Observable<string | null> {
    return this.role$;
  }

  logout() {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(USERNAME);
    localStorage.removeItem(EMAIL);
    localStorage.removeItem(ID_USER);
    this._role.set(null);
    this._router.navigate(['/login']);
  }

  isLoggedIn() {
    return localStorage.getItem(TOKEN);
  }

  changePassword(
    password: string,
    currentPassword: string,
    passwordConfirmation: string
  ): Observable<any> {
    return this._http.post(BASEURL + 'auth/change-password', {
      password,
      currentPassword,
      passwordConfirmation,
    }).pipe(catchError(this.handleError));
  }

  resetPassword(email: string): Observable<any> {
    return this._http.post(BASEURL + 'auth/forgot-password', { email }).pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse) => {
    let errorMessage = 'Error en el servicio de Autenticación.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('AuthService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
